module.exports = __webpack_public_path__ + "img/jxk_shjc.4febb733.svg";